import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-maintenance-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './maintenance-page.html',
  styleUrls: ['./maintenance-page.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenancePageComponent {
  @Input() maintenanceEndTime: Date | null = null;
}
